// extracted by mini-css-extract-plugin
module.exports = {"exception":"RuleExceptionModal_exception__30JW5"};